import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const testimonials = [
  {
    quote:
      "QUZY has transformed how I prepare for my exams. The AI-generated quizzes are perfectly tailored to my learning style, and the analytics help me focus on areas where I need improvement. My test scores have improved significantly!",
    name: "Sarah Johnson",
    title: "University Student",
    image: "https://randomuser.me/api/portraits/women/1.jpg",
  },
  {
    quote:
      "As a teacher, QUZY has been a game-changer for my classroom. I can quickly create engaging quizzes that challenge my students at the right level. The time I save on quiz creation allows me to focus more on personalized instruction.",
    name: "Michael Rodriguez",
    title: "High School Teacher",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  {
    quote:
      "The progress tracking feature in QUZY is exceptional. I can see exactly which concepts I've mastered and which ones need more work. The personalized recommendations have helped me study more efficiently than ever before.",
    name: "Emily Chen",
    title: "Medical Student",
    image: "https://randomuser.me/api/portraits/women/2.jpg",
  },
  {
    quote:
      "I've tried many quiz apps, but QUZY stands out with its intuitive interface and smart question generation. The app seems to understand exactly what I need to learn next. It's like having a personal tutor in my pocket!",
    name: "David Wilson",
    title: "Software Developer",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
  },
  {
    quote:
      "Our entire study group uses QUZY to prepare for certification exams. The collaborative features let us share quizzes and compete in a friendly way. It's made studying fun again, and our pass rate has improved dramatically.",
    name: "Priya Patel",
    title: "IT Professional",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024, // Tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="bg-white py-16">
      <div className="text-center mb-10">
        <h2 className="text-4xl md:text-6xl font-bold text-gray-400 uppercase opacity-10 mb-2">
          Testimonials
        </h2>
        <h3 className="text-4xl md:text-5xl font-bold -mt-8 relative z-10 bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent">
          TESTIMONIALS
        </h3>
        <p className="text-gray-600 mt-2">
          See what our users are saying about their experience with QUZY
        </p>
      </div>

      <div className="max-w-6xl mx-auto px-4">
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="px-4 py-4 h-full">
              <div className="bg-indigo-100 p-6 rounded-lg shadow-md text-center flex flex-col items-center  justify-between">
                <div className="flex-grow flex flex-col justify-center">
                  <p className="italic text-gray-600">
                    <span className="text-indigo-500 text-6xl leading-none">
                      "
                    </span>
                  
                    {testimonial.quote}
                   
                 {/* <span className="text-indigo-500 text-4xl leading-none">
                      "
                    </span> */}
                  </p>
                </div>

                <div className="mt-auto pt-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full border-2 border-white shadow mx-auto mb-2"
                  />
                  <h4 className="font-bold text-lg text-gray-800">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500">{testimonial.title}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
